import logo from '../../assets/goodvale_logo.png';
import wordmark from '../../assets/goodvale_wordmark.png';
import { Newspaper, HeartHandshake, Users, ShieldCheck, CirclePlus, ClipboardCheck, ChartNoAxesCombined, CircleDollarSign } from 'lucide-react';
import de from './de.json';
import en from './en.json';
const files = import.meta.glob('./assets/*.svg', { eager: true, query: '?url', import: 'default' });
const iconFiles = import.meta.glob('./assets/icons/community-icon-*.webp', { eager: true, query: '?url&no-inline', import: 'default' });
const photos = import.meta.glob('./assets/*.webp', { eager: true, query: '?url', import: 'default' });
const categories = {"SCOUT":"MOBILITY_OUTDOOR","MEDIC":"HEALTH_WELLNESS","SOCIAL":"ENTERTAINMENT_GASTRO","TANK":"HARDWARE_FITNESS","ENVIRONMENT":"ECO_NATURE","TECH":"TECH_EDUCATION","CRAFTER":"CRAFTING_REPAIR","NUTRITION":"FOOD_GROCERIES","LOGISTICS":"LOGISTICS_RETAIL","GUARDIAN":"SOCIAL_COMMUNITY"};
const icon = (kind, key) => iconFiles[`./assets/icons/community-icon-${kind}-${String(key || '').toLowerCase().replaceAll('_','-')}.webp`]
  || iconFiles['./assets/icons/community-icon-class-guardian.webp'];
const roomImage = { forge:'shop', design:'hall', stats:'trophies', settings:'hall' };
const currentAppearance = () => typeof document !== 'undefined' && document.documentElement.classList.contains('light') ? 'light' : 'dark';
const photo = (name, appearance) => photos[`./assets/${name}${appearance === 'dark' ? '-dark' : ''}.webp`]
  || photos[`./assets/${name}.webp`];
export default {
  messages: { de, en },
  featureIcons: { news:Newspaper, action:HeartHandshake, group:Users, trust:ShieldCheck, benefits:CirclePlus, review:ClipboardCheck, engagement:ChartNoAxesCombined, points:CircleDollarSign },
  ornamentation: 'minimal',
  logo, wordmark,
  icon: (kind, key) => {
    if (kind === 'category') {
      const catKey = categories[key] || key;
      return icon(kind, catKey);
    }
    return icon(kind, key);
  },
  scene: (key, appearance) => photo(String(key).toLowerCase()+'-scene', appearance)
    || files['./assets/'+String(key).toLowerCase()+'-scene.svg'] || photo('scout-scene', appearance),
  guildImage: (theme, room) => (roomImage[room] || room) === 'hall'
    ? photo(String(theme)+'-hall', currentAppearance()) || photo('default-hall', currentAppearance())
    : photo('room-'+String(roomImage[room] || room), currentAppearance()) || files['./assets/'+String(theme)+'-'+String(room)+'.svg'] || photo('default-hall', currentAppearance()),
  stageImage: () => null,
  get errorImage() { return photo('guardian-scene', currentAppearance()); },
  get preview() { return photo('tech-scene', currentAppearance()); },
  flyer: (audience, language) => '/downloads/goodvale-community-'+audience+'-'+language,
};
